import React from 'react';

import { GrabTargetProps } from './types';
import { Component } from './styles';

export const GrabTarget = React.memo(
  React.forwardRef<HTMLDivElement, GrabTargetProps>(({ children }, ref) => {
    return <Component ref={ref}>{children}</Component>;
  })
);
